import { Box, Container, Stack, Typography } from "@mui/material";
import SuperChatPrompt from "@/templates/SuperChatPrompt";
import { BackButton } from "@/organism";
import useCreatePrompt from "./useCreatePrompt";

/**
 * QNA 채팅 프롬프트 생성 페이지
 * @description 새로운 QNA 채팅 프롬프트를 생성하는 페이지입니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export const CreatePrompt = () => {
  const { isLoading, handleSubmit } = useCreatePrompt();

  return (
    <Container maxWidth={"xl"} key="chat-prompt-create">
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/chat/content"}>컨텐츠 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            프롬프트 생성
          </Typography>
        </Stack>
      </Box>
      <SuperChatPrompt.CreateForm
        key="chat-prompt-form"
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </Container>
  );
};
